import { render, staticRenderFns } from "./ReservationInfoMobile.vue?vue&type=template&id=21cbd9d4&scoped=true&"
import script from "./ReservationInfoMobile.vue?vue&type=script&lang=js&"
export * from "./ReservationInfoMobile.vue?vue&type=script&lang=js&"
import style0 from "./ReservationInfoMobile.vue?vue&type=style&index=0&id=21cbd9d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cbd9d4",
  null
  
)

export default component.exports